import { render, staticRenderFns } from "./OrdersMainView.vue?vue&type=template&id=409c054a"
import script from "./OrdersMainView.vue?vue&type=script&lang=js"
export * from "./OrdersMainView.vue?vue&type=script&lang=js"
import style0 from "./OrdersMainView.vue?vue&type=style&index=0&id=409c054a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports